<!--
 * @Author: Gaho
 * @Date: 2024-03-22 17:15:42
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-11 14:00:56
 * @Description: 
-->
<template>
    <div class="history-result" ref="randomNumRef" v-if="gameHistory?.response?.length">
        <div
            v-for="(v, k) in gameHistory?.response?.slice(0, 14)"
            class="history-result-item"
            :class="[v.winAmount > 0 ? 'bg-[#3ecc7f]' : 'bg-[#e04461]']"
            :key="k"
        >
            {{ v.roll_number }}x
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useJoinStateStore } from '@/stores/cansino/joinState';
export default defineComponent({
    name: 'historyResult',
    computed: {
        gameHistory(){
            const { gameHistoryDelay } = useGameHistoryStore();
            // 路由切换到别的游戏后，还会触发computed-gameHistory，防止这种问题出现
            if (useJoinStateStore().gameOfRoute !== 'limboGame'){
                return;
            }
            console.log(gameHistoryDelay, 'gameHistoryDelay')
            return gameHistoryDelay;
        }
    },
});
</script>
<style lang="scss" scoped>
.history-result {
    display: flex;
    flex-direction: row-reverse;
    overflow: hidden;
    position: absolute;
    right: 15px;
    top: 15px;
    width: calc(100% - 35px);
    &::after {
        background: linear-gradient(90deg, #162c4a, rgba(22, 44, 74, 0));
        bottom: 0;
        content: '';
        display: block;
        left: -1px;
        position: absolute;
        top: 0;
        width: 50px;
    }
    @media (max-width: 768px) {
        right: 0;
        top: -30px;
        width: 100%;
    }
    .history-result-item {
        align-items: center;
        animation-duration: 325ms;
        animation-fill-mode: forwards;
        animation-timing-function: linear;
        border-radius: 3px;
        color: #fff;
        display: flex;
        font-size: 10px;
        font-weight: 600;
        justify-content: center;
        margin-left: 3px;
        min-width: 50px;
        overflow: hidden;
        padding: 4.5px;
        position: relative;
        user-select: none;

        &:first-child {
            animation-name: horizont-1;
        }
        &:nth-child(2n) {
            animation-name: horizont-2;
        }
        &:nth-child(odd) {
            animation-name: horizont-3;
        }
    }
}
@keyframes horizont-1 {
    0% {
        opacity: 0;
        transform: translateX(99.9%)
    }
}

@keyframes horizont-2 {
    0% {
        transform: translate(99.9%)
    }
}

@keyframes horizont-3 {
    0% {
        transform: translate(99.9%)
    }
}
</style>